import { forwardRef, memo } from 'react';
import { declension } from '@utils/declension';
import './index.scss';

interface AddMoreBtnProps {
  balanceItems: number;
  titleArray: [string, string, string];
  callback: () => void;
}

const AddMoreBtn = forwardRef<HTMLDivElement, AddMoreBtnProps>(
  ({ balanceItems, titleArray, callback }, ref) => (
    <div ref={ref} className='add-more-btn' onClick={callback}>
      Показать еще {balanceItems} {declension(balanceItems, titleArray)}
    </div>
  )
);
export default memo(AddMoreBtn);
